<template>
  <div class="form-item">
    <input type="email" v-model="inputValue" placeholder="email cím">
  </div>
</template>
<script>
import {miniFieldMixin} from '../../mixin/minifield'
export default {
  name: "Mail",
  mixins: [
    miniFieldMixin(function(value){
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)
    })
  ]
}
</script>
<style lang="scss">
</style>
